import React from "react";

export const AuthContext = React.createContext({});
export const UserThemeContext = React.createContext({});
export const SessionDataContext = React.createContext({});
export const DataContext = React.createContext({});
export const DialogsContext = React.createContext({});